export default __webpack_public_path__ + "static/media/4.cef90d0d.jpg";